module.exports = __webpack_public_path__ + "img/tet.84ad4863.jpg";